export { default as RecordsList } from './List';
export { default as RecordCreate } from './Form/Create';
export { default as RecordEdit } from './Form/Edit';
export { default as Show } from './Form/Show';
